import { Row, Drawer } from "antd";
import ProductPanelSM from "../../../components/PointOfSale/Retail/productPanelSM";
import GroupedProducts from "../../../lib/components/GroupedProducts";

const ProductPanelsSection = ({
  // ProductPanelSM shared props
  checkIsManualWeight,
  setIsSearchProducts,
  getMoreProducts,
  productItems,
  setProductItems,
  selectProductInCart,
  setProductArray,
  isProductsFilter,
  getSearchedProducts,
  productListCardRef,
  productsDisplay,
  isProductsVisible,
  setIsProductsVisible,
  pickProduct,
  filterDrawer,
  setFilterDrawer,
  productSearchInput,
  setProductSearchInput,
  setOpen,
  keyboardType,
  setKeyboardType,
  productSearchInputRef,
  clearProductSearchResults,
  productsData,
  productSearchRef,
  handleSelectProduct,
  productsList,
  setProductsList,
  setLayoutName,
  productPanelSearchRef,
  setInputName,
  keyboard,
  searchInputRef,
  setCart,
  // Drawer-specific
  closeProductPanel,
  isQtyUpdate,
  // GroupedProducts props
  showCustomMix,
  setShowCustomMix,
  cart,
  customMixItems,
  setCustomMixItems,
  groupName,
  setGroupName,
  groupQty,
  setGroupQty,
  existingGroupItems,
  setExistingGroupItems,
  selectedCustomMix,
  setSelectedCustomMix,
  orderType,
  setOrderType,
  posSaleTypes,
  setPosSaleTypes,
  currenciesData,
  setCurrenciesData,
  setActiveInput,
  setProductStock,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
}) => {
  return (
    <>
      {/* Product panel drawer (bottom) */}
      <Drawer
        placement="bottom"
        height="75vh"
        title={null}
        closeIcon={null}
        className="filter"
        styles={{ header: { height: 0 } }}
        styles={{ body: { paddingTop: 0 } }}
        open={isProductsVisible}
        closable={true}
        onClose={closeProductPanel}
        footer={null}
      >
        <Row style={{ paddingTop: isQtyUpdate ? 0 : "1.7%", width: "100%", paddingLeft: "1vw" }}>
          <ProductPanelSM
            checkIsManualWeight={checkIsManualWeight}
            setIsSearchProducts={setIsSearchProducts}
            getMoreProducts={getMoreProducts}
            productItems={productItems}
            setProductItems={setProductItems}
            selectProductInCart={selectProductInCart}
            setProductArray={setProductArray}
            isProductsFilter={isProductsFilter}
            getSearchedProducts={getSearchedProducts}
            productListCardRef={productListCardRef}
            productsDisplay={productsDisplay}
            setIsProductsVisible={setIsProductsVisible}
            pickProduct={pickProduct}
            filterDrawer={filterDrawer}
            setFilterDrawer={setFilterDrawer}
            productSearchInput={productSearchInput}
            setProductSearchInput={setProductSearchInput}
            setOpen={setOpen}
            keyboardType={keyboardType}
            setKeyboardType={setKeyboardType}
            productSearchInputRef={productSearchInputRef}
            clearProductSearchResults={clearProductSearchResults}
            productsData={productsData}
            isProductsVisible={isProductsVisible}
            productSearchRef={productSearchRef}
            handleSelectProduct={handleSelectProduct}
            productsList={productsList}
            setProductsList={setProductsList}
            setLayoutName={setLayoutName}
            productPanelSearchRef={productPanelSearchRef}
            setInputName={setInputName}
            keyboard={keyboard}
            searchInputRef={searchInputRef}
            setCart={setCart}
          />
        </Row>
      </Drawer>
      <ProductPanelSM
        checkIsManualWeight={checkIsManualWeight}
        setIsSearchProducts={setIsSearchProducts}
        getMoreProducts={getMoreProducts}
        productItems={productItems}
        setProductItems={setProductItems}
        selectProductInCart={selectProductInCart}
        isProductsFilter={isProductsFilter}
        getSearchedProducts={getSearchedProducts}
        productListCardRef={productListCardRef}
        productsDisplay={productsDisplay}
        isProductsVisible={isProductsVisible}
        setIsProductsVisible={setIsProductsVisible}
        pickProduct={pickProduct}
        filterDrawer={filterDrawer}
        setFilterDrawer={setFilterDrawer}
        productSearchInput={productSearchInput}
        setProductSearchInput={setProductSearchInput}
        setOpen={setOpen}
        keyboardType={keyboardType}
        setKeyboardType={setKeyboardType}
        productSearchInputRef={productSearchInputRef}
        clearProductSearchResults={clearProductSearchResults}
        productsData={productsData}
        productSearchRef={productSearchRef}
        handleSelectProduct={handleSelectProduct}
        productsList={productsList}
        setProductsList={setProductsList}
        setLayoutName={setLayoutName}
        productPanelSearchRef={productPanelSearchRef}
        setInputName={setInputName}
        keyboard={keyboard}
        searchInputRef={searchInputRef}
        setCart={setCart}
      />
      <GroupedProducts
        showCustomMix={showCustomMix}
        setShowCustomMix={setShowCustomMix}
        cart={cart}
        setCart={setCart}
        customMixItems={customMixItems}
        setCustomMixItems={setCustomMixItems}
        groupName={groupName}
        setGroupName={setGroupName}
        groupQty={groupQty}
        setGroupQty={setGroupQty}
        existingGroupItems={existingGroupItems}
        setExistingGroupItems={setExistingGroupItems}
        selectedCustomMix={selectedCustomMix}
        setSelectedCustomMix={setSelectedCustomMix}
        orderType={orderType}
        setOrderType={setOrderType}
        posSaleTypes={posSaleTypes}
        setPosSaleTypes={setPosSaleTypes}
        currenciesData={currenciesData}
        setCurrenciesData={setCurrenciesData}
        searchInputRef={searchInputRef}
        setActiveInput={setActiveInput}
        setProductStock={setProductStock}
        setShowCompleteSaleStock={setShowCompleteSaleStock}
        setCompleteSaleStockData={setCompleteSaleStockData}
      />
    </>
  );
};

export default ProductPanelsSection;
